<template>
  <div class="dialog-root">
    <div class="container">
      <div class="sub-title">处理说明</div>
      <el-input type="textarea" v-model="handleMessage" maxlength="200" show-word-limit> </el-input>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 底部操作按钮 -->
    <div class="btn">
      <el-button type="primary" size="small" @click="doSave"> 保存 </el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import { dealVoiceMsgApi } from '@/api/call-system/call-manage/voice-message';

export default {
  props: ['rowData'],
  data() {
    return {
      handleMessage: '',
    };
  },
  methods: {
    /* 保存 */
    doSave() {
      dealVoiceMsgApi(
        {
          id: this.rowData.id,
          handleMessage: this.handleMessage,
        },
        {
          showLoading: { text: '处理中...' },
        }
      ).then(() => {
        this.$message.success('操作成功!');
        this.$emit('update');
      });
    },
    /* 取消 */
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}

.sub-title {
  margin-bottom: 10px;
}
</style>
